import firebase from "firebase";
import "firebase/functions";
import { notification } from "antd";

export const getApiCallable = (callable) => {
  // firebase.functions().useFunctionsEmulator("http://localhost:5001")
  return firebase.functions().httpsCallable(callable);
}

export const showNotif = (error) => {
  if (error.code === "failed-precondition" || error.code === "invalid-argument") {
    notification.error({
      message: error.message
    });
  }
}
